/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  StructureColumnType_Enum,
  structureColumnType_EnumFromJSON,
  structureColumnType_EnumToJSON,
} from "../scan_planner/structure_column_type";
import { AutoRegionRequest } from "../user_camera/auto_region_request";
import {
  AutofocusMode_Enum,
  autofocusMode_EnumFromJSON,
  autofocusMode_EnumToJSON,
} from "../user_camera/autofocus_mode";
import { AwbMode_Enum, awbMode_EnumFromJSON, awbMode_EnumToJSON } from "../user_camera/awb_mode";
import {
  CompensationMode_Enum,
  compensationMode_EnumFromJSON,
  compensationMode_EnumToJSON,
} from "../user_camera/compensation_mode";
import { ExposureMode_Enum, exposureMode_EnumFromJSON, exposureMode_EnumToJSON } from "../user_camera/exposure_mode";
import {
  RecordingMode_Enum,
  recordingMode_EnumFromJSON,
  recordingMode_EnumToJSON,
} from "../user_camera/recording_mode";
import { ScanMode_Enum, scanMode_EnumFromJSON, scanMode_EnumToJSON } from "./scan_mode";
import {
  SpecificationSelection_Enum,
  specificationSelection_EnumFromJSON,
  specificationSelection_EnumToJSON,
} from "./specification_selection";
import { UserControls } from "./user_controls";
import {
  WaypointExecutionMode_Enum,
  waypointExecutionMode_EnumFromJSON,
  waypointExecutionMode_EnumToJSON,
} from "./waypoint_execution_mode";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SettingsManager {
  scanModeLcm: ScanMode_Enum;
  runAreaScan: boolean;
  runPerimeterScan: boolean;
  runOrbitScan: boolean;
  runMeshScan: boolean;
  runContourZScan: boolean;
  runContourYScan: boolean;
  runContourXScan: boolean;
  runContourCustomScan: boolean;
  runManualScan: boolean;
  runColumnScan: boolean;
  runVertexColumnScan: boolean;
  runStructureColumnInspectionScan: boolean;
  runDiagonalScan: boolean;
  stopForPhoto: boolean;
  ignoreTranslationMotionBlurConstraint: boolean;
  maxMotionBlurPx: number;
  overlapPercentage: number;
  distanceToSurface: number;
  showArCoverageMesh: boolean;
  awbMode: AwbMode_Enum;
  exposureMode: ExposureMode_Enum;
  autofocusRegion: AutoRegionRequest | undefined;
  autofocusMode: AutofocusMode_Enum;
  eoRecordingMode: RecordingMode_Enum;
  geofenceStrictCeiling: boolean;
  geofenceCeilOffset: number;
  geofenceStrictFloor: boolean;
  geofenceFloorOffset: number;
  geofenceStrictLateral: boolean;
  geofenceLateralOffset: number;
  geofenceOffsetFloorFromPolygonPrismCeiling: boolean;
  minDistanceFromSurface: number;
  useGeofenceArea: boolean;
  exteriorCaptureCeil: boolean;
  exteriorCaptureFloor: boolean;
  exteriorCaptureLateral: boolean;
  scanVolumeInside: boolean;
  scanVolumeExtendCaptureDistance: number;
  areaScanHeight: number;
  areaOverlap: number;
  areaSidelap: number;
  areaGimbalPitch: number;
  enableCrossHatch: boolean;
  crossHatchGimbalAngle: number;
  enableCustomFlightLegDirection: boolean;
  customFlightLegDirection: number;
  enableCustomCameraHeading: boolean;
  ccwPerpendicularCameraHeading: boolean;
  scanPlaneOffsetFromNavTakeoff: number;
  perimeterOverlap: number;
  perimeterGimbalPitch: number;
  perimeterNumHeights: number;
  perimeterMinDistanceToScanPlane: number;
  diagonalOverlap: number;
  diagonalGimbalPitch: number;
  rollingShutterCorrection: boolean;
  isLookupScan: boolean;
  orbitSidelap: number;
  orbitGimbalPitch: number;
  orbitUseHelix: boolean;
  numColumns: number;
  columnOverlap: number;
  columnGimbalPitch: number;
  contourDesiredRange: number;
  contourWaypointOverlapPercentage: number;
  contourSliceOverlapPercentage: number;
  contourZLookdownAngle: number;
  avoidRedundantCoverage: boolean;
  adjustUnreachablePhotos: boolean;
  contourNumPasses: number;
  contourPassMultiplier: number;
  contourSlicePitch: number;
  contourSliceYaw: number;
  contourSmallGapsDistance: number;
  contourLongRange: boolean;
  verticalOverlapFractionPercentage: number;
  gimbalPitchDeg: number;
  lengthTower: number;
  upAndOverHeight: number;
  standoffDistance: number;
  explorationOrbitRadius: number;
  explorationOrbitHeight: number;
  towerHeight: number;
  towerWidth: number;
  towerDepth: number;
  nadirExecutionMode: WaypointExecutionMode_Enum;
  nadirFillImage: number;
  overviewExecutionMode: WaypointExecutionMode_Enum;
  overviewGimbalPitchDown: number;
  insulatorExecutionMode: WaypointExecutionMode_Enum;
  columnPlanType: StructureColumnType_Enum;
  useSemanticInspectionGimbalPitchUp: boolean;
  semanticInspectionGimbalPitchUp: number;
  useSemanticInspectionGimbalPitchStraight: boolean;
  useSemanticInspectionGimbalPitchDown: boolean;
  semanticInspectionGimbalPitchDown: number;
  towerBodyExecutionMode: WaypointExecutionMode_Enum;
  towerBodyEnabled: boolean;
  towerBodyTakePhoto: boolean;
  towerBodyPitch: number;
  towerBodyOverlap: number;
  spanExecutionMode: WaypointExecutionMode_Enum;
  spanEnabled: boolean;
  spanTakePhoto: boolean;
  autonomousTowerAlignment: boolean;
  useSemanticAim: boolean;
  numberPitchAngles: number;
  nadirTakePhoto: boolean;
  overviewEnabled: boolean;
  overviewTakePhoto: boolean;
  insulatorEnabled: boolean;
  insulatorTakePhoto: boolean;
  semanticInspectionGimbalPitchStraight: number;
  columnIndices: number[];
  compensationMode: CompensationMode_Enum;
  useGlobalMapFromRtk: boolean;
  useExplorationPhase: boolean;
  useMeshExplore: boolean;
  useLongRangeExplore: boolean;
  useOrbitExploration: boolean;
  globalMaximumSpeed: number;
  globalSupportOutsideGeofencePoints: boolean;
  splitExplorationIsEnabled: boolean;
  splitExplorationIsCumulative: boolean;
  splitExplorationIsTopToBottom: boolean;
  splitExplorationSliceHeight: number;
  specificationSelection: SpecificationSelection_Enum;
  usePillarCursor: boolean;
  usePillarCursorMarker: boolean;
  useExtremeCursor: boolean;
  lockAwbAtFirstWaypoint: boolean;
  lockAfAtFirstWaypoint: boolean;
  useGpsScanPose: boolean;
  lostCommsWaitTime: number;
  lostCommsRallyWaitTime: number;
  numPhotosPerOrbit: number;
  lookOutwards: boolean;
  orbitCounterClockwise: boolean;
  takeIrPhotos: boolean;
  takeRawPhotos: boolean;
  terrainFollow: boolean;
  useRealTimeTerrainDetection: boolean;
  userControls: UserControls | undefined;
  dtedMapPath: string;
}

function createBaseSettingsManager(): SettingsManager {
  return {
    scanModeLcm: 0,
    runAreaScan: false,
    runPerimeterScan: false,
    runOrbitScan: false,
    runMeshScan: false,
    runContourZScan: false,
    runContourYScan: false,
    runContourXScan: false,
    runContourCustomScan: false,
    runManualScan: false,
    runColumnScan: false,
    runVertexColumnScan: false,
    runStructureColumnInspectionScan: false,
    runDiagonalScan: false,
    stopForPhoto: false,
    ignoreTranslationMotionBlurConstraint: false,
    maxMotionBlurPx: 0,
    overlapPercentage: 0,
    distanceToSurface: 0,
    showArCoverageMesh: false,
    awbMode: 0,
    exposureMode: 0,
    autofocusRegion: undefined,
    autofocusMode: 0,
    eoRecordingMode: 0,
    geofenceStrictCeiling: false,
    geofenceCeilOffset: 0,
    geofenceStrictFloor: false,
    geofenceFloorOffset: 0,
    geofenceStrictLateral: false,
    geofenceLateralOffset: 0,
    geofenceOffsetFloorFromPolygonPrismCeiling: false,
    minDistanceFromSurface: 0,
    useGeofenceArea: false,
    exteriorCaptureCeil: false,
    exteriorCaptureFloor: false,
    exteriorCaptureLateral: false,
    scanVolumeInside: false,
    scanVolumeExtendCaptureDistance: 0,
    areaScanHeight: 0,
    areaOverlap: 0,
    areaSidelap: 0,
    areaGimbalPitch: 0,
    enableCrossHatch: false,
    crossHatchGimbalAngle: 0,
    enableCustomFlightLegDirection: false,
    customFlightLegDirection: 0,
    enableCustomCameraHeading: false,
    ccwPerpendicularCameraHeading: false,
    scanPlaneOffsetFromNavTakeoff: 0,
    perimeterOverlap: 0,
    perimeterGimbalPitch: 0,
    perimeterNumHeights: 0,
    perimeterMinDistanceToScanPlane: 0,
    diagonalOverlap: 0,
    diagonalGimbalPitch: 0,
    rollingShutterCorrection: false,
    isLookupScan: false,
    orbitSidelap: 0,
    orbitGimbalPitch: 0,
    orbitUseHelix: false,
    numColumns: 0,
    columnOverlap: 0,
    columnGimbalPitch: 0,
    contourDesiredRange: 0,
    contourWaypointOverlapPercentage: 0,
    contourSliceOverlapPercentage: 0,
    contourZLookdownAngle: 0,
    avoidRedundantCoverage: false,
    adjustUnreachablePhotos: false,
    contourNumPasses: 0,
    contourPassMultiplier: 0,
    contourSlicePitch: 0,
    contourSliceYaw: 0,
    contourSmallGapsDistance: 0,
    contourLongRange: false,
    verticalOverlapFractionPercentage: 0,
    gimbalPitchDeg: 0,
    lengthTower: 0,
    upAndOverHeight: 0,
    standoffDistance: 0,
    explorationOrbitRadius: 0,
    explorationOrbitHeight: 0,
    towerHeight: 0,
    towerWidth: 0,
    towerDepth: 0,
    nadirExecutionMode: 0,
    nadirFillImage: 0,
    overviewExecutionMode: 0,
    overviewGimbalPitchDown: 0,
    insulatorExecutionMode: 0,
    columnPlanType: 0,
    useSemanticInspectionGimbalPitchUp: false,
    semanticInspectionGimbalPitchUp: 0,
    useSemanticInspectionGimbalPitchStraight: false,
    useSemanticInspectionGimbalPitchDown: false,
    semanticInspectionGimbalPitchDown: 0,
    towerBodyExecutionMode: 0,
    towerBodyEnabled: false,
    towerBodyTakePhoto: false,
    towerBodyPitch: 0,
    towerBodyOverlap: 0,
    spanExecutionMode: 0,
    spanEnabled: false,
    spanTakePhoto: false,
    autonomousTowerAlignment: false,
    useSemanticAim: false,
    numberPitchAngles: 0,
    nadirTakePhoto: false,
    overviewEnabled: false,
    overviewTakePhoto: false,
    insulatorEnabled: false,
    insulatorTakePhoto: false,
    semanticInspectionGimbalPitchStraight: 0,
    columnIndices: [],
    compensationMode: 0,
    useGlobalMapFromRtk: false,
    useExplorationPhase: false,
    useMeshExplore: false,
    useLongRangeExplore: false,
    useOrbitExploration: false,
    globalMaximumSpeed: 0,
    globalSupportOutsideGeofencePoints: false,
    splitExplorationIsEnabled: false,
    splitExplorationIsCumulative: false,
    splitExplorationIsTopToBottom: false,
    splitExplorationSliceHeight: 0,
    specificationSelection: 0,
    usePillarCursor: false,
    usePillarCursorMarker: false,
    useExtremeCursor: false,
    lockAwbAtFirstWaypoint: false,
    lockAfAtFirstWaypoint: false,
    useGpsScanPose: false,
    lostCommsWaitTime: 0,
    lostCommsRallyWaitTime: 0,
    numPhotosPerOrbit: 0,
    lookOutwards: false,
    orbitCounterClockwise: false,
    takeIrPhotos: false,
    takeRawPhotos: false,
    terrainFollow: false,
    useRealTimeTerrainDetection: false,
    userControls: undefined,
    dtedMapPath: "",
  };
}

export const SettingsManager = {
  encode(message: SettingsManager, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.scanModeLcm !== 0) {
      writer.uint32(8).int32(message.scanModeLcm);
    }
    if (message.runAreaScan === true) {
      writer.uint32(16).bool(message.runAreaScan);
    }
    if (message.runPerimeterScan === true) {
      writer.uint32(24).bool(message.runPerimeterScan);
    }
    if (message.runOrbitScan === true) {
      writer.uint32(32).bool(message.runOrbitScan);
    }
    if (message.runMeshScan === true) {
      writer.uint32(48).bool(message.runMeshScan);
    }
    if (message.runContourZScan === true) {
      writer.uint32(608).bool(message.runContourZScan);
    }
    if (message.runContourYScan === true) {
      writer.uint32(600).bool(message.runContourYScan);
    }
    if (message.runContourXScan === true) {
      writer.uint32(592).bool(message.runContourXScan);
    }
    if (message.runContourCustomScan === true) {
      writer.uint32(1096).bool(message.runContourCustomScan);
    }
    if (message.runManualScan === true) {
      writer.uint32(56).bool(message.runManualScan);
    }
    if (message.runColumnScan === true) {
      writer.uint32(808).bool(message.runColumnScan);
    }
    if (message.runVertexColumnScan === true) {
      writer.uint32(816).bool(message.runVertexColumnScan);
    }
    if (message.runStructureColumnInspectionScan === true) {
      writer.uint32(1232).bool(message.runStructureColumnInspectionScan);
    }
    if (message.runDiagonalScan === true) {
      writer.uint32(1656).bool(message.runDiagonalScan);
    }
    if (message.stopForPhoto === true) {
      writer.uint32(624).bool(message.stopForPhoto);
    }
    if (message.ignoreTranslationMotionBlurConstraint === true) {
      writer.uint32(1504).bool(message.ignoreTranslationMotionBlurConstraint);
    }
    if (message.maxMotionBlurPx !== 0) {
      writer.uint32(1680).uint32(message.maxMotionBlurPx);
    }
    if (message.overlapPercentage !== 0) {
      writer.uint32(85).float(message.overlapPercentage);
    }
    if (message.distanceToSurface !== 0) {
      writer.uint32(93).float(message.distanceToSurface);
    }
    if (message.showArCoverageMesh === true) {
      writer.uint32(616).bool(message.showArCoverageMesh);
    }
    if (message.awbMode !== 0) {
      writer.uint32(544).int32(message.awbMode);
    }
    if (message.exposureMode !== 0) {
      writer.uint32(552).int32(message.exposureMode);
    }
    if (message.autofocusRegion !== undefined) {
      AutoRegionRequest.encode(message.autofocusRegion, writer.uint32(1202).fork()).ldelim();
    }
    if (message.autofocusMode !== 0) {
      writer.uint32(1208).int32(message.autofocusMode);
    }
    if (message.eoRecordingMode !== 0) {
      writer.uint32(1328).int32(message.eoRecordingMode);
    }
    if (message.geofenceStrictCeiling === true) {
      writer.uint32(752).bool(message.geofenceStrictCeiling);
    }
    if (message.geofenceCeilOffset !== 0) {
      writer.uint32(181).float(message.geofenceCeilOffset);
    }
    if (message.geofenceStrictFloor === true) {
      writer.uint32(760).bool(message.geofenceStrictFloor);
    }
    if (message.geofenceFloorOffset !== 0) {
      writer.uint32(197).float(message.geofenceFloorOffset);
    }
    if (message.geofenceStrictLateral === true) {
      writer.uint32(768).bool(message.geofenceStrictLateral);
    }
    if (message.geofenceLateralOffset !== 0) {
      writer.uint32(781).float(message.geofenceLateralOffset);
    }
    if (message.geofenceOffsetFloorFromPolygonPrismCeiling === true) {
      writer.uint32(1216).bool(message.geofenceOffsetFloorFromPolygonPrismCeiling);
    }
    if (message.minDistanceFromSurface !== 0) {
      writer.uint32(741).float(message.minDistanceFromSurface);
    }
    if (message.useGeofenceArea === true) {
      writer.uint32(1008).bool(message.useGeofenceArea);
    }
    if (message.exteriorCaptureCeil === true) {
      writer.uint32(784).bool(message.exteriorCaptureCeil);
    }
    if (message.exteriorCaptureFloor === true) {
      writer.uint32(792).bool(message.exteriorCaptureFloor);
    }
    if (message.exteriorCaptureLateral === true) {
      writer.uint32(800).bool(message.exteriorCaptureLateral);
    }
    if (message.scanVolumeInside === true) {
      writer.uint32(1120).bool(message.scanVolumeInside);
    }
    if (message.scanVolumeExtendCaptureDistance !== 0) {
      writer.uint32(1133).float(message.scanVolumeExtendCaptureDistance);
    }
    if (message.areaScanHeight !== 0) {
      writer.uint32(221).float(message.areaScanHeight);
    }
    if (message.areaOverlap !== 0) {
      writer.uint32(229).float(message.areaOverlap);
    }
    if (message.areaSidelap !== 0) {
      writer.uint32(237).float(message.areaSidelap);
    }
    if (message.areaGimbalPitch !== 0) {
      writer.uint32(1389).float(message.areaGimbalPitch);
    }
    if (message.enableCrossHatch === true) {
      writer.uint32(240).bool(message.enableCrossHatch);
    }
    if (message.crossHatchGimbalAngle !== 0) {
      writer.uint32(253).float(message.crossHatchGimbalAngle);
    }
    if (message.enableCustomFlightLegDirection === true) {
      writer.uint32(1360).bool(message.enableCustomFlightLegDirection);
    }
    if (message.customFlightLegDirection !== 0) {
      writer.uint32(1373).float(message.customFlightLegDirection);
    }
    if (message.enableCustomCameraHeading === true) {
      writer.uint32(1392).bool(message.enableCustomCameraHeading);
    }
    if (message.ccwPerpendicularCameraHeading === true) {
      writer.uint32(1400).bool(message.ccwPerpendicularCameraHeading);
    }
    if (message.scanPlaneOffsetFromNavTakeoff !== 0) {
      writer.uint32(1709).float(message.scanPlaneOffsetFromNavTakeoff);
    }
    if (message.perimeterOverlap !== 0) {
      writer.uint32(709).float(message.perimeterOverlap);
    }
    if (message.perimeterGimbalPitch !== 0) {
      writer.uint32(277).float(message.perimeterGimbalPitch);
    }
    if (message.perimeterNumHeights !== 0) {
      writer.uint32(280).sint64(message.perimeterNumHeights);
    }
    if (message.perimeterMinDistanceToScanPlane !== 0) {
      writer.uint32(293).float(message.perimeterMinDistanceToScanPlane);
    }
    if (message.diagonalOverlap !== 0) {
      writer.uint32(1669).float(message.diagonalOverlap);
    }
    if (message.diagonalGimbalPitch !== 0) {
      writer.uint32(1677).float(message.diagonalGimbalPitch);
    }
    if (message.rollingShutterCorrection === true) {
      writer.uint32(1512).bool(message.rollingShutterCorrection);
    }
    if (message.isLookupScan === true) {
      writer.uint32(856).bool(message.isLookupScan);
    }
    if (message.orbitSidelap !== 0) {
      writer.uint32(997).float(message.orbitSidelap);
    }
    if (message.orbitGimbalPitch !== 0) {
      writer.uint32(869).float(message.orbitGimbalPitch);
    }
    if (message.orbitUseHelix === true) {
      writer.uint32(1024).bool(message.orbitUseHelix);
    }
    if (message.numColumns !== 0) {
      writer.uint32(1160).uint32(message.numColumns);
    }
    if (message.columnOverlap !== 0) {
      writer.uint32(925).float(message.columnOverlap);
    }
    if (message.columnGimbalPitch !== 0) {
      writer.uint32(941).float(message.columnGimbalPitch);
    }
    if (message.contourDesiredRange !== 0) {
      writer.uint32(573).float(message.contourDesiredRange);
    }
    if (message.contourWaypointOverlapPercentage !== 0) {
      writer.uint32(589).float(message.contourWaypointOverlapPercentage);
    }
    if (message.contourSliceOverlapPercentage !== 0) {
      writer.uint32(581).float(message.contourSliceOverlapPercentage);
    }
    if (message.contourZLookdownAngle !== 0) {
      writer.uint32(653).float(message.contourZLookdownAngle);
    }
    if (message.avoidRedundantCoverage === true) {
      writer.uint32(720).bool(message.avoidRedundantCoverage);
    }
    if (message.adjustUnreachablePhotos === true) {
      writer.uint32(728).bool(message.adjustUnreachablePhotos);
    }
    if (message.contourNumPasses !== 0) {
      writer.uint32(968).sint64(message.contourNumPasses);
    }
    if (message.contourPassMultiplier !== 0) {
      writer.uint32(981).float(message.contourPassMultiplier);
    }
    if (message.contourSlicePitch !== 0) {
      writer.uint32(1085).float(message.contourSlicePitch);
    }
    if (message.contourSliceYaw !== 0) {
      writer.uint32(1093).float(message.contourSliceYaw);
    }
    if (message.contourSmallGapsDistance !== 0) {
      writer.uint32(1173).float(message.contourSmallGapsDistance);
    }
    if (message.contourLongRange === true) {
      writer.uint32(1192).bool(message.contourLongRange);
    }
    if (message.verticalOverlapFractionPercentage !== 0) {
      writer.uint32(829).float(message.verticalOverlapFractionPercentage);
    }
    if (message.gimbalPitchDeg !== 0) {
      writer.uint32(837).float(message.gimbalPitchDeg);
    }
    if (message.lengthTower !== 0) {
      writer.uint32(845).float(message.lengthTower);
    }
    if (message.upAndOverHeight !== 0) {
      writer.uint32(853).float(message.upAndOverHeight);
    }
    if (message.standoffDistance !== 0) {
      writer.uint32(1293).float(message.standoffDistance);
    }
    if (message.explorationOrbitRadius !== 0) {
      writer.uint32(1325).float(message.explorationOrbitRadius);
    }
    if (message.explorationOrbitHeight !== 0) {
      writer.uint32(1357).float(message.explorationOrbitHeight);
    }
    if (message.towerHeight !== 0) {
      writer.uint32(1453).float(message.towerHeight);
    }
    if (message.towerWidth !== 0) {
      writer.uint32(1277).float(message.towerWidth);
    }
    if (message.towerDepth !== 0) {
      writer.uint32(1285).float(message.towerDepth);
    }
    if (message.nadirExecutionMode !== 0) {
      writer.uint32(1456).int32(message.nadirExecutionMode);
    }
    if (message.nadirFillImage !== 0) {
      writer.uint32(1501).float(message.nadirFillImage);
    }
    if (message.overviewExecutionMode !== 0) {
      writer.uint32(1488).int32(message.overviewExecutionMode);
    }
    if (message.overviewGimbalPitchDown !== 0) {
      writer.uint32(1413).float(message.overviewGimbalPitchDown);
    }
    if (message.insulatorExecutionMode !== 0) {
      writer.uint32(1424).int32(message.insulatorExecutionMode);
    }
    if (message.columnPlanType !== 0) {
      writer.uint32(1296).int32(message.columnPlanType);
    }
    if (message.useSemanticInspectionGimbalPitchUp === true) {
      writer.uint32(1256).bool(message.useSemanticInspectionGimbalPitchUp);
    }
    if (message.semanticInspectionGimbalPitchUp !== 0) {
      writer.uint32(1245).float(message.semanticInspectionGimbalPitchUp);
    }
    if (message.useSemanticInspectionGimbalPitchStraight === true) {
      writer.uint32(1464).bool(message.useSemanticInspectionGimbalPitchStraight);
    }
    if (message.useSemanticInspectionGimbalPitchDown === true) {
      writer.uint32(1264).bool(message.useSemanticInspectionGimbalPitchDown);
    }
    if (message.semanticInspectionGimbalPitchDown !== 0) {
      writer.uint32(1253).float(message.semanticInspectionGimbalPitchDown);
    }
    if (message.towerBodyExecutionMode !== 0) {
      writer.uint32(1432).int32(message.towerBodyExecutionMode);
    }
    if (message.towerBodyEnabled === true) {
      writer.uint32(1520).bool(message.towerBodyEnabled);
    }
    if (message.towerBodyTakePhoto === true) {
      writer.uint32(1528).bool(message.towerBodyTakePhoto);
    }
    if (message.towerBodyPitch !== 0) {
      writer.uint32(1485).float(message.towerBodyPitch);
    }
    if (message.towerBodyOverlap !== 0) {
      writer.uint32(1477).float(message.towerBodyOverlap);
    }
    if (message.spanExecutionMode !== 0) {
      writer.uint32(1440).int32(message.spanExecutionMode);
    }
    if (message.spanEnabled === true) {
      writer.uint32(1536).bool(message.spanEnabled);
    }
    if (message.spanTakePhoto === true) {
      writer.uint32(1544).bool(message.spanTakePhoto);
    }
    if (message.autonomousTowerAlignment === true) {
      writer.uint32(1376).bool(message.autonomousTowerAlignment);
    }
    if (message.useSemanticAim === true) {
      writer.uint32(1344).bool(message.useSemanticAim);
    }
    if (message.numberPitchAngles !== 0) {
      writer.uint32(1560).sint32(message.numberPitchAngles);
    }
    if (message.nadirTakePhoto === true) {
      writer.uint32(1568).bool(message.nadirTakePhoto);
    }
    if (message.overviewEnabled === true) {
      writer.uint32(1576).bool(message.overviewEnabled);
    }
    if (message.overviewTakePhoto === true) {
      writer.uint32(1584).bool(message.overviewTakePhoto);
    }
    if (message.insulatorEnabled === true) {
      writer.uint32(1592).bool(message.insulatorEnabled);
    }
    if (message.insulatorTakePhoto === true) {
      writer.uint32(1600).bool(message.insulatorTakePhoto);
    }
    if (message.semanticInspectionGimbalPitchStraight !== 0) {
      writer.uint32(1613).float(message.semanticInspectionGimbalPitchStraight);
    }
    writer.uint32(1618).fork();
    for (const v of message.columnIndices) {
      writer.sint32(v);
    }
    writer.ldelim();
    if (message.compensationMode !== 0) {
      writer.uint32(1640).int32(message.compensationMode);
    }
    if (message.useGlobalMapFromRtk === true) {
      writer.uint32(1648).bool(message.useGlobalMapFromRtk);
    }
    if (message.useExplorationPhase === true) {
      writer.uint32(488).bool(message.useExplorationPhase);
    }
    if (message.useMeshExplore === true) {
      writer.uint32(1176).bool(message.useMeshExplore);
    }
    if (message.useLongRangeExplore === true) {
      writer.uint32(1184).bool(message.useLongRangeExplore);
    }
    if (message.useOrbitExploration === true) {
      writer.uint32(1304).bool(message.useOrbitExploration);
    }
    if (message.globalMaximumSpeed !== 0) {
      writer.uint32(1021).float(message.globalMaximumSpeed);
    }
    if (message.globalSupportOutsideGeofencePoints === true) {
      writer.uint32(1136).bool(message.globalSupportOutsideGeofencePoints);
    }
    if (message.splitExplorationIsEnabled === true) {
      writer.uint32(1104).bool(message.splitExplorationIsEnabled);
    }
    if (message.splitExplorationIsCumulative === true) {
      writer.uint32(1056).bool(message.splitExplorationIsCumulative);
    }
    if (message.splitExplorationIsTopToBottom === true) {
      writer.uint32(1064).bool(message.splitExplorationIsTopToBottom);
    }
    if (message.splitExplorationSliceHeight !== 0) {
      writer.uint32(1117).float(message.splitExplorationSliceHeight);
    }
    if (message.specificationSelection !== 0) {
      writer.uint32(328).int32(message.specificationSelection);
    }
    if (message.usePillarCursor === true) {
      writer.uint32(448).bool(message.usePillarCursor);
    }
    if (message.usePillarCursorMarker === true) {
      writer.uint32(672).bool(message.usePillarCursorMarker);
    }
    if (message.useExtremeCursor === true) {
      writer.uint32(656).bool(message.useExtremeCursor);
    }
    if (message.lockAwbAtFirstWaypoint === true) {
      writer.uint32(1552).bool(message.lockAwbAtFirstWaypoint);
    }
    if (message.lockAfAtFirstWaypoint === true) {
      writer.uint32(1688).bool(message.lockAfAtFirstWaypoint);
    }
    if (message.useGpsScanPose === true) {
      writer.uint32(368).bool(message.useGpsScanPose);
    }
    if (message.lostCommsWaitTime !== 0) {
      writer.uint32(397).float(message.lostCommsWaitTime);
    }
    if (message.lostCommsRallyWaitTime !== 0) {
      writer.uint32(413).float(message.lostCommsRallyWaitTime);
    }
    if (message.numPhotosPerOrbit !== 0) {
      writer.uint32(296).sint64(message.numPhotosPerOrbit);
    }
    if (message.lookOutwards === true) {
      writer.uint32(1144).bool(message.lookOutwards);
    }
    if (message.orbitCounterClockwise === true) {
      writer.uint32(1152).bool(message.orbitCounterClockwise);
    }
    if (message.takeIrPhotos === true) {
      writer.uint32(1224).bool(message.takeIrPhotos);
    }
    if (message.takeRawPhotos === true) {
      writer.uint32(1336).bool(message.takeRawPhotos);
    }
    if (message.terrainFollow === true) {
      writer.uint32(1624).bool(message.terrainFollow);
    }
    if (message.useRealTimeTerrainDetection === true) {
      writer.uint32(1632).bool(message.useRealTimeTerrainDetection);
    }
    if (message.userControls !== undefined) {
      UserControls.encode(message.userControls, writer.uint32(1314).fork()).ldelim();
    }
    if (message.dtedMapPath !== "") {
      writer.uint32(1698).string(message.dtedMapPath);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SettingsManager {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSettingsManager();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.scanModeLcm = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.runAreaScan = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.runPerimeterScan = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.runOrbitScan = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.runMeshScan = reader.bool();
          continue;
        case 76:
          if (tag !== 608) {
            break;
          }

          message.runContourZScan = reader.bool();
          continue;
        case 75:
          if (tag !== 600) {
            break;
          }

          message.runContourYScan = reader.bool();
          continue;
        case 74:
          if (tag !== 592) {
            break;
          }

          message.runContourXScan = reader.bool();
          continue;
        case 137:
          if (tag !== 1096) {
            break;
          }

          message.runContourCustomScan = reader.bool();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.runManualScan = reader.bool();
          continue;
        case 101:
          if (tag !== 808) {
            break;
          }

          message.runColumnScan = reader.bool();
          continue;
        case 102:
          if (tag !== 816) {
            break;
          }

          message.runVertexColumnScan = reader.bool();
          continue;
        case 154:
          if (tag !== 1232) {
            break;
          }

          message.runStructureColumnInspectionScan = reader.bool();
          continue;
        case 207:
          if (tag !== 1656) {
            break;
          }

          message.runDiagonalScan = reader.bool();
          continue;
        case 78:
          if (tag !== 624) {
            break;
          }

          message.stopForPhoto = reader.bool();
          continue;
        case 188:
          if (tag !== 1504) {
            break;
          }

          message.ignoreTranslationMotionBlurConstraint = reader.bool();
          continue;
        case 210:
          if (tag !== 1680) {
            break;
          }

          message.maxMotionBlurPx = reader.uint32();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.overlapPercentage = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.distanceToSurface = reader.float();
          continue;
        case 77:
          if (tag !== 616) {
            break;
          }

          message.showArCoverageMesh = reader.bool();
          continue;
        case 68:
          if (tag !== 544) {
            break;
          }

          message.awbMode = reader.int32() as any;
          continue;
        case 69:
          if (tag !== 552) {
            break;
          }

          message.exposureMode = reader.int32() as any;
          continue;
        case 150:
          if (tag !== 1202) {
            break;
          }

          message.autofocusRegion = AutoRegionRequest.decode(reader, reader.uint32());
          continue;
        case 151:
          if (tag !== 1208) {
            break;
          }

          message.autofocusMode = reader.int32() as any;
          continue;
        case 166:
          if (tag !== 1328) {
            break;
          }

          message.eoRecordingMode = reader.int32() as any;
          continue;
        case 94:
          if (tag !== 752) {
            break;
          }

          message.geofenceStrictCeiling = reader.bool();
          continue;
        case 22:
          if (tag !== 181) {
            break;
          }

          message.geofenceCeilOffset = reader.float();
          continue;
        case 95:
          if (tag !== 760) {
            break;
          }

          message.geofenceStrictFloor = reader.bool();
          continue;
        case 24:
          if (tag !== 197) {
            break;
          }

          message.geofenceFloorOffset = reader.float();
          continue;
        case 96:
          if (tag !== 768) {
            break;
          }

          message.geofenceStrictLateral = reader.bool();
          continue;
        case 97:
          if (tag !== 781) {
            break;
          }

          message.geofenceLateralOffset = reader.float();
          continue;
        case 152:
          if (tag !== 1216) {
            break;
          }

          message.geofenceOffsetFloorFromPolygonPrismCeiling = reader.bool();
          continue;
        case 92:
          if (tag !== 741) {
            break;
          }

          message.minDistanceFromSurface = reader.float();
          continue;
        case 126:
          if (tag !== 1008) {
            break;
          }

          message.useGeofenceArea = reader.bool();
          continue;
        case 98:
          if (tag !== 784) {
            break;
          }

          message.exteriorCaptureCeil = reader.bool();
          continue;
        case 99:
          if (tag !== 792) {
            break;
          }

          message.exteriorCaptureFloor = reader.bool();
          continue;
        case 100:
          if (tag !== 800) {
            break;
          }

          message.exteriorCaptureLateral = reader.bool();
          continue;
        case 140:
          if (tag !== 1120) {
            break;
          }

          message.scanVolumeInside = reader.bool();
          continue;
        case 141:
          if (tag !== 1133) {
            break;
          }

          message.scanVolumeExtendCaptureDistance = reader.float();
          continue;
        case 27:
          if (tag !== 221) {
            break;
          }

          message.areaScanHeight = reader.float();
          continue;
        case 28:
          if (tag !== 229) {
            break;
          }

          message.areaOverlap = reader.float();
          continue;
        case 29:
          if (tag !== 237) {
            break;
          }

          message.areaSidelap = reader.float();
          continue;
        case 173:
          if (tag !== 1389) {
            break;
          }

          message.areaGimbalPitch = reader.float();
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.enableCrossHatch = reader.bool();
          continue;
        case 31:
          if (tag !== 253) {
            break;
          }

          message.crossHatchGimbalAngle = reader.float();
          continue;
        case 170:
          if (tag !== 1360) {
            break;
          }

          message.enableCustomFlightLegDirection = reader.bool();
          continue;
        case 171:
          if (tag !== 1373) {
            break;
          }

          message.customFlightLegDirection = reader.float();
          continue;
        case 174:
          if (tag !== 1392) {
            break;
          }

          message.enableCustomCameraHeading = reader.bool();
          continue;
        case 175:
          if (tag !== 1400) {
            break;
          }

          message.ccwPerpendicularCameraHeading = reader.bool();
          continue;
        case 213:
          if (tag !== 1709) {
            break;
          }

          message.scanPlaneOffsetFromNavTakeoff = reader.float();
          continue;
        case 88:
          if (tag !== 709) {
            break;
          }

          message.perimeterOverlap = reader.float();
          continue;
        case 34:
          if (tag !== 277) {
            break;
          }

          message.perimeterGimbalPitch = reader.float();
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.perimeterNumHeights = longToNumber(reader.sint64() as Long);
          continue;
        case 36:
          if (tag !== 293) {
            break;
          }

          message.perimeterMinDistanceToScanPlane = reader.float();
          continue;
        case 208:
          if (tag !== 1669) {
            break;
          }

          message.diagonalOverlap = reader.float();
          continue;
        case 209:
          if (tag !== 1677) {
            break;
          }

          message.diagonalGimbalPitch = reader.float();
          continue;
        case 189:
          if (tag !== 1512) {
            break;
          }

          message.rollingShutterCorrection = reader.bool();
          continue;
        case 107:
          if (tag !== 856) {
            break;
          }

          message.isLookupScan = reader.bool();
          continue;
        case 124:
          if (tag !== 997) {
            break;
          }

          message.orbitSidelap = reader.float();
          continue;
        case 108:
          if (tag !== 869) {
            break;
          }

          message.orbitGimbalPitch = reader.float();
          continue;
        case 128:
          if (tag !== 1024) {
            break;
          }

          message.orbitUseHelix = reader.bool();
          continue;
        case 145:
          if (tag !== 1160) {
            break;
          }

          message.numColumns = reader.uint32();
          continue;
        case 115:
          if (tag !== 925) {
            break;
          }

          message.columnOverlap = reader.float();
          continue;
        case 117:
          if (tag !== 941) {
            break;
          }

          message.columnGimbalPitch = reader.float();
          continue;
        case 71:
          if (tag !== 573) {
            break;
          }

          message.contourDesiredRange = reader.float();
          continue;
        case 73:
          if (tag !== 589) {
            break;
          }

          message.contourWaypointOverlapPercentage = reader.float();
          continue;
        case 72:
          if (tag !== 581) {
            break;
          }

          message.contourSliceOverlapPercentage = reader.float();
          continue;
        case 81:
          if (tag !== 653) {
            break;
          }

          message.contourZLookdownAngle = reader.float();
          continue;
        case 90:
          if (tag !== 720) {
            break;
          }

          message.avoidRedundantCoverage = reader.bool();
          continue;
        case 91:
          if (tag !== 728) {
            break;
          }

          message.adjustUnreachablePhotos = reader.bool();
          continue;
        case 121:
          if (tag !== 968) {
            break;
          }

          message.contourNumPasses = longToNumber(reader.sint64() as Long);
          continue;
        case 122:
          if (tag !== 981) {
            break;
          }

          message.contourPassMultiplier = reader.float();
          continue;
        case 135:
          if (tag !== 1085) {
            break;
          }

          message.contourSlicePitch = reader.float();
          continue;
        case 136:
          if (tag !== 1093) {
            break;
          }

          message.contourSliceYaw = reader.float();
          continue;
        case 146:
          if (tag !== 1173) {
            break;
          }

          message.contourSmallGapsDistance = reader.float();
          continue;
        case 149:
          if (tag !== 1192) {
            break;
          }

          message.contourLongRange = reader.bool();
          continue;
        case 103:
          if (tag !== 829) {
            break;
          }

          message.verticalOverlapFractionPercentage = reader.float();
          continue;
        case 104:
          if (tag !== 837) {
            break;
          }

          message.gimbalPitchDeg = reader.float();
          continue;
        case 105:
          if (tag !== 845) {
            break;
          }

          message.lengthTower = reader.float();
          continue;
        case 106:
          if (tag !== 853) {
            break;
          }

          message.upAndOverHeight = reader.float();
          continue;
        case 161:
          if (tag !== 1293) {
            break;
          }

          message.standoffDistance = reader.float();
          continue;
        case 165:
          if (tag !== 1325) {
            break;
          }

          message.explorationOrbitRadius = reader.float();
          continue;
        case 169:
          if (tag !== 1357) {
            break;
          }

          message.explorationOrbitHeight = reader.float();
          continue;
        case 181:
          if (tag !== 1453) {
            break;
          }

          message.towerHeight = reader.float();
          continue;
        case 159:
          if (tag !== 1277) {
            break;
          }

          message.towerWidth = reader.float();
          continue;
        case 160:
          if (tag !== 1285) {
            break;
          }

          message.towerDepth = reader.float();
          continue;
        case 182:
          if (tag !== 1456) {
            break;
          }

          message.nadirExecutionMode = reader.int32() as any;
          continue;
        case 187:
          if (tag !== 1501) {
            break;
          }

          message.nadirFillImage = reader.float();
          continue;
        case 186:
          if (tag !== 1488) {
            break;
          }

          message.overviewExecutionMode = reader.int32() as any;
          continue;
        case 176:
          if (tag !== 1413) {
            break;
          }

          message.overviewGimbalPitchDown = reader.float();
          continue;
        case 178:
          if (tag !== 1424) {
            break;
          }

          message.insulatorExecutionMode = reader.int32() as any;
          continue;
        case 162:
          if (tag !== 1296) {
            break;
          }

          message.columnPlanType = reader.int32() as any;
          continue;
        case 157:
          if (tag !== 1256) {
            break;
          }

          message.useSemanticInspectionGimbalPitchUp = reader.bool();
          continue;
        case 155:
          if (tag !== 1245) {
            break;
          }

          message.semanticInspectionGimbalPitchUp = reader.float();
          continue;
        case 183:
          if (tag !== 1464) {
            break;
          }

          message.useSemanticInspectionGimbalPitchStraight = reader.bool();
          continue;
        case 158:
          if (tag !== 1264) {
            break;
          }

          message.useSemanticInspectionGimbalPitchDown = reader.bool();
          continue;
        case 156:
          if (tag !== 1253) {
            break;
          }

          message.semanticInspectionGimbalPitchDown = reader.float();
          continue;
        case 179:
          if (tag !== 1432) {
            break;
          }

          message.towerBodyExecutionMode = reader.int32() as any;
          continue;
        case 190:
          if (tag !== 1520) {
            break;
          }

          message.towerBodyEnabled = reader.bool();
          continue;
        case 191:
          if (tag !== 1528) {
            break;
          }

          message.towerBodyTakePhoto = reader.bool();
          continue;
        case 185:
          if (tag !== 1485) {
            break;
          }

          message.towerBodyPitch = reader.float();
          continue;
        case 184:
          if (tag !== 1477) {
            break;
          }

          message.towerBodyOverlap = reader.float();
          continue;
        case 180:
          if (tag !== 1440) {
            break;
          }

          message.spanExecutionMode = reader.int32() as any;
          continue;
        case 192:
          if (tag !== 1536) {
            break;
          }

          message.spanEnabled = reader.bool();
          continue;
        case 193:
          if (tag !== 1544) {
            break;
          }

          message.spanTakePhoto = reader.bool();
          continue;
        case 172:
          if (tag !== 1376) {
            break;
          }

          message.autonomousTowerAlignment = reader.bool();
          continue;
        case 168:
          if (tag !== 1344) {
            break;
          }

          message.useSemanticAim = reader.bool();
          continue;
        case 195:
          if (tag !== 1560) {
            break;
          }

          message.numberPitchAngles = reader.sint32();
          continue;
        case 196:
          if (tag !== 1568) {
            break;
          }

          message.nadirTakePhoto = reader.bool();
          continue;
        case 197:
          if (tag !== 1576) {
            break;
          }

          message.overviewEnabled = reader.bool();
          continue;
        case 198:
          if (tag !== 1584) {
            break;
          }

          message.overviewTakePhoto = reader.bool();
          continue;
        case 199:
          if (tag !== 1592) {
            break;
          }

          message.insulatorEnabled = reader.bool();
          continue;
        case 200:
          if (tag !== 1600) {
            break;
          }

          message.insulatorTakePhoto = reader.bool();
          continue;
        case 201:
          if (tag !== 1613) {
            break;
          }

          message.semanticInspectionGimbalPitchStraight = reader.float();
          continue;
        case 202:
          if (tag === 1616) {
            message.columnIndices.push(reader.sint32());

            continue;
          }

          if (tag === 1618) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.columnIndices.push(reader.sint32());
            }

            continue;
          }

          break;
        case 205:
          if (tag !== 1640) {
            break;
          }

          message.compensationMode = reader.int32() as any;
          continue;
        case 206:
          if (tag !== 1648) {
            break;
          }

          message.useGlobalMapFromRtk = reader.bool();
          continue;
        case 61:
          if (tag !== 488) {
            break;
          }

          message.useExplorationPhase = reader.bool();
          continue;
        case 147:
          if (tag !== 1176) {
            break;
          }

          message.useMeshExplore = reader.bool();
          continue;
        case 148:
          if (tag !== 1184) {
            break;
          }

          message.useLongRangeExplore = reader.bool();
          continue;
        case 163:
          if (tag !== 1304) {
            break;
          }

          message.useOrbitExploration = reader.bool();
          continue;
        case 127:
          if (tag !== 1021) {
            break;
          }

          message.globalMaximumSpeed = reader.float();
          continue;
        case 142:
          if (tag !== 1136) {
            break;
          }

          message.globalSupportOutsideGeofencePoints = reader.bool();
          continue;
        case 138:
          if (tag !== 1104) {
            break;
          }

          message.splitExplorationIsEnabled = reader.bool();
          continue;
        case 132:
          if (tag !== 1056) {
            break;
          }

          message.splitExplorationIsCumulative = reader.bool();
          continue;
        case 133:
          if (tag !== 1064) {
            break;
          }

          message.splitExplorationIsTopToBottom = reader.bool();
          continue;
        case 139:
          if (tag !== 1117) {
            break;
          }

          message.splitExplorationSliceHeight = reader.float();
          continue;
        case 41:
          if (tag !== 328) {
            break;
          }

          message.specificationSelection = reader.int32() as any;
          continue;
        case 56:
          if (tag !== 448) {
            break;
          }

          message.usePillarCursor = reader.bool();
          continue;
        case 84:
          if (tag !== 672) {
            break;
          }

          message.usePillarCursorMarker = reader.bool();
          continue;
        case 82:
          if (tag !== 656) {
            break;
          }

          message.useExtremeCursor = reader.bool();
          continue;
        case 194:
          if (tag !== 1552) {
            break;
          }

          message.lockAwbAtFirstWaypoint = reader.bool();
          continue;
        case 211:
          if (tag !== 1688) {
            break;
          }

          message.lockAfAtFirstWaypoint = reader.bool();
          continue;
        case 46:
          if (tag !== 368) {
            break;
          }

          message.useGpsScanPose = reader.bool();
          continue;
        case 49:
          if (tag !== 397) {
            break;
          }

          message.lostCommsWaitTime = reader.float();
          continue;
        case 51:
          if (tag !== 413) {
            break;
          }

          message.lostCommsRallyWaitTime = reader.float();
          continue;
        case 37:
          if (tag !== 296) {
            break;
          }

          message.numPhotosPerOrbit = longToNumber(reader.sint64() as Long);
          continue;
        case 143:
          if (tag !== 1144) {
            break;
          }

          message.lookOutwards = reader.bool();
          continue;
        case 144:
          if (tag !== 1152) {
            break;
          }

          message.orbitCounterClockwise = reader.bool();
          continue;
        case 153:
          if (tag !== 1224) {
            break;
          }

          message.takeIrPhotos = reader.bool();
          continue;
        case 167:
          if (tag !== 1336) {
            break;
          }

          message.takeRawPhotos = reader.bool();
          continue;
        case 203:
          if (tag !== 1624) {
            break;
          }

          message.terrainFollow = reader.bool();
          continue;
        case 204:
          if (tag !== 1632) {
            break;
          }

          message.useRealTimeTerrainDetection = reader.bool();
          continue;
        case 164:
          if (tag !== 1314) {
            break;
          }

          message.userControls = UserControls.decode(reader, reader.uint32());
          continue;
        case 212:
          if (tag !== 1698) {
            break;
          }

          message.dtedMapPath = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SettingsManager {
    return {
      scanModeLcm: isSet(object.scanModeLcm) ? scanMode_EnumFromJSON(object.scanModeLcm) : 0,
      runAreaScan: isSet(object.runAreaScan) ? globalThis.Boolean(object.runAreaScan) : false,
      runPerimeterScan: isSet(object.runPerimeterScan) ? globalThis.Boolean(object.runPerimeterScan) : false,
      runOrbitScan: isSet(object.runOrbitScan) ? globalThis.Boolean(object.runOrbitScan) : false,
      runMeshScan: isSet(object.runMeshScan) ? globalThis.Boolean(object.runMeshScan) : false,
      runContourZScan: isSet(object.runContourZScan) ? globalThis.Boolean(object.runContourZScan) : false,
      runContourYScan: isSet(object.runContourYScan) ? globalThis.Boolean(object.runContourYScan) : false,
      runContourXScan: isSet(object.runContourXScan) ? globalThis.Boolean(object.runContourXScan) : false,
      runContourCustomScan: isSet(object.runContourCustomScan)
        ? globalThis.Boolean(object.runContourCustomScan)
        : false,
      runManualScan: isSet(object.runManualScan) ? globalThis.Boolean(object.runManualScan) : false,
      runColumnScan: isSet(object.runColumnScan) ? globalThis.Boolean(object.runColumnScan) : false,
      runVertexColumnScan: isSet(object.runVertexColumnScan) ? globalThis.Boolean(object.runVertexColumnScan) : false,
      runStructureColumnInspectionScan: isSet(object.runStructureColumnInspectionScan)
        ? globalThis.Boolean(object.runStructureColumnInspectionScan)
        : false,
      runDiagonalScan: isSet(object.runDiagonalScan) ? globalThis.Boolean(object.runDiagonalScan) : false,
      stopForPhoto: isSet(object.stopForPhoto) ? globalThis.Boolean(object.stopForPhoto) : false,
      ignoreTranslationMotionBlurConstraint: isSet(object.ignoreTranslationMotionBlurConstraint)
        ? globalThis.Boolean(object.ignoreTranslationMotionBlurConstraint)
        : false,
      maxMotionBlurPx: isSet(object.maxMotionBlurPx) ? globalThis.Number(object.maxMotionBlurPx) : 0,
      overlapPercentage: isSet(object.overlapPercentage) ? globalThis.Number(object.overlapPercentage) : 0,
      distanceToSurface: isSet(object.distanceToSurface) ? globalThis.Number(object.distanceToSurface) : 0,
      showArCoverageMesh: isSet(object.showArCoverageMesh) ? globalThis.Boolean(object.showArCoverageMesh) : false,
      awbMode: isSet(object.awbMode) ? awbMode_EnumFromJSON(object.awbMode) : 0,
      exposureMode: isSet(object.exposureMode) ? exposureMode_EnumFromJSON(object.exposureMode) : 0,
      autofocusRegion: isSet(object.autofocusRegion) ? AutoRegionRequest.fromJSON(object.autofocusRegion) : undefined,
      autofocusMode: isSet(object.autofocusMode) ? autofocusMode_EnumFromJSON(object.autofocusMode) : 0,
      eoRecordingMode: isSet(object.eoRecordingMode) ? recordingMode_EnumFromJSON(object.eoRecordingMode) : 0,
      geofenceStrictCeiling: isSet(object.geofenceStrictCeiling)
        ? globalThis.Boolean(object.geofenceStrictCeiling)
        : false,
      geofenceCeilOffset: isSet(object.geofenceCeilOffset) ? globalThis.Number(object.geofenceCeilOffset) : 0,
      geofenceStrictFloor: isSet(object.geofenceStrictFloor) ? globalThis.Boolean(object.geofenceStrictFloor) : false,
      geofenceFloorOffset: isSet(object.geofenceFloorOffset) ? globalThis.Number(object.geofenceFloorOffset) : 0,
      geofenceStrictLateral: isSet(object.geofenceStrictLateral)
        ? globalThis.Boolean(object.geofenceStrictLateral)
        : false,
      geofenceLateralOffset: isSet(object.geofenceLateralOffset) ? globalThis.Number(object.geofenceLateralOffset) : 0,
      geofenceOffsetFloorFromPolygonPrismCeiling: isSet(object.geofenceOffsetFloorFromPolygonPrismCeiling)
        ? globalThis.Boolean(object.geofenceOffsetFloorFromPolygonPrismCeiling)
        : false,
      minDistanceFromSurface: isSet(object.minDistanceFromSurface)
        ? globalThis.Number(object.minDistanceFromSurface)
        : 0,
      useGeofenceArea: isSet(object.useGeofenceArea) ? globalThis.Boolean(object.useGeofenceArea) : false,
      exteriorCaptureCeil: isSet(object.exteriorCaptureCeil) ? globalThis.Boolean(object.exteriorCaptureCeil) : false,
      exteriorCaptureFloor: isSet(object.exteriorCaptureFloor)
        ? globalThis.Boolean(object.exteriorCaptureFloor)
        : false,
      exteriorCaptureLateral: isSet(object.exteriorCaptureLateral)
        ? globalThis.Boolean(object.exteriorCaptureLateral)
        : false,
      scanVolumeInside: isSet(object.scanVolumeInside) ? globalThis.Boolean(object.scanVolumeInside) : false,
      scanVolumeExtendCaptureDistance: isSet(object.scanVolumeExtendCaptureDistance)
        ? globalThis.Number(object.scanVolumeExtendCaptureDistance)
        : 0,
      areaScanHeight: isSet(object.areaScanHeight) ? globalThis.Number(object.areaScanHeight) : 0,
      areaOverlap: isSet(object.areaOverlap) ? globalThis.Number(object.areaOverlap) : 0,
      areaSidelap: isSet(object.areaSidelap) ? globalThis.Number(object.areaSidelap) : 0,
      areaGimbalPitch: isSet(object.areaGimbalPitch) ? globalThis.Number(object.areaGimbalPitch) : 0,
      enableCrossHatch: isSet(object.enableCrossHatch) ? globalThis.Boolean(object.enableCrossHatch) : false,
      crossHatchGimbalAngle: isSet(object.crossHatchGimbalAngle) ? globalThis.Number(object.crossHatchGimbalAngle) : 0,
      enableCustomFlightLegDirection: isSet(object.enableCustomFlightLegDirection)
        ? globalThis.Boolean(object.enableCustomFlightLegDirection)
        : false,
      customFlightLegDirection: isSet(object.customFlightLegDirection)
        ? globalThis.Number(object.customFlightLegDirection)
        : 0,
      enableCustomCameraHeading: isSet(object.enableCustomCameraHeading)
        ? globalThis.Boolean(object.enableCustomCameraHeading)
        : false,
      ccwPerpendicularCameraHeading: isSet(object.ccwPerpendicularCameraHeading)
        ? globalThis.Boolean(object.ccwPerpendicularCameraHeading)
        : false,
      scanPlaneOffsetFromNavTakeoff: isSet(object.scanPlaneOffsetFromNavTakeoff)
        ? globalThis.Number(object.scanPlaneOffsetFromNavTakeoff)
        : 0,
      perimeterOverlap: isSet(object.perimeterOverlap) ? globalThis.Number(object.perimeterOverlap) : 0,
      perimeterGimbalPitch: isSet(object.perimeterGimbalPitch) ? globalThis.Number(object.perimeterGimbalPitch) : 0,
      perimeterNumHeights: isSet(object.perimeterNumHeights) ? globalThis.Number(object.perimeterNumHeights) : 0,
      perimeterMinDistanceToScanPlane: isSet(object.perimeterMinDistanceToScanPlane)
        ? globalThis.Number(object.perimeterMinDistanceToScanPlane)
        : 0,
      diagonalOverlap: isSet(object.diagonalOverlap) ? globalThis.Number(object.diagonalOverlap) : 0,
      diagonalGimbalPitch: isSet(object.diagonalGimbalPitch) ? globalThis.Number(object.diagonalGimbalPitch) : 0,
      rollingShutterCorrection: isSet(object.rollingShutterCorrection)
        ? globalThis.Boolean(object.rollingShutterCorrection)
        : false,
      isLookupScan: isSet(object.isLookupScan) ? globalThis.Boolean(object.isLookupScan) : false,
      orbitSidelap: isSet(object.orbitSidelap) ? globalThis.Number(object.orbitSidelap) : 0,
      orbitGimbalPitch: isSet(object.orbitGimbalPitch) ? globalThis.Number(object.orbitGimbalPitch) : 0,
      orbitUseHelix: isSet(object.orbitUseHelix) ? globalThis.Boolean(object.orbitUseHelix) : false,
      numColumns: isSet(object.numColumns) ? globalThis.Number(object.numColumns) : 0,
      columnOverlap: isSet(object.columnOverlap) ? globalThis.Number(object.columnOverlap) : 0,
      columnGimbalPitch: isSet(object.columnGimbalPitch) ? globalThis.Number(object.columnGimbalPitch) : 0,
      contourDesiredRange: isSet(object.contourDesiredRange) ? globalThis.Number(object.contourDesiredRange) : 0,
      contourWaypointOverlapPercentage: isSet(object.contourWaypointOverlapPercentage)
        ? globalThis.Number(object.contourWaypointOverlapPercentage)
        : 0,
      contourSliceOverlapPercentage: isSet(object.contourSliceOverlapPercentage)
        ? globalThis.Number(object.contourSliceOverlapPercentage)
        : 0,
      contourZLookdownAngle: isSet(object.contourZLookdownAngle) ? globalThis.Number(object.contourZLookdownAngle) : 0,
      avoidRedundantCoverage: isSet(object.avoidRedundantCoverage)
        ? globalThis.Boolean(object.avoidRedundantCoverage)
        : false,
      adjustUnreachablePhotos: isSet(object.adjustUnreachablePhotos)
        ? globalThis.Boolean(object.adjustUnreachablePhotos)
        : false,
      contourNumPasses: isSet(object.contourNumPasses) ? globalThis.Number(object.contourNumPasses) : 0,
      contourPassMultiplier: isSet(object.contourPassMultiplier) ? globalThis.Number(object.contourPassMultiplier) : 0,
      contourSlicePitch: isSet(object.contourSlicePitch) ? globalThis.Number(object.contourSlicePitch) : 0,
      contourSliceYaw: isSet(object.contourSliceYaw) ? globalThis.Number(object.contourSliceYaw) : 0,
      contourSmallGapsDistance: isSet(object.contourSmallGapsDistance)
        ? globalThis.Number(object.contourSmallGapsDistance)
        : 0,
      contourLongRange: isSet(object.contourLongRange) ? globalThis.Boolean(object.contourLongRange) : false,
      verticalOverlapFractionPercentage: isSet(object.verticalOverlapFractionPercentage)
        ? globalThis.Number(object.verticalOverlapFractionPercentage)
        : 0,
      gimbalPitchDeg: isSet(object.gimbalPitchDeg) ? globalThis.Number(object.gimbalPitchDeg) : 0,
      lengthTower: isSet(object.lengthTower) ? globalThis.Number(object.lengthTower) : 0,
      upAndOverHeight: isSet(object.upAndOverHeight) ? globalThis.Number(object.upAndOverHeight) : 0,
      standoffDistance: isSet(object.standoffDistance) ? globalThis.Number(object.standoffDistance) : 0,
      explorationOrbitRadius: isSet(object.explorationOrbitRadius)
        ? globalThis.Number(object.explorationOrbitRadius)
        : 0,
      explorationOrbitHeight: isSet(object.explorationOrbitHeight)
        ? globalThis.Number(object.explorationOrbitHeight)
        : 0,
      towerHeight: isSet(object.towerHeight) ? globalThis.Number(object.towerHeight) : 0,
      towerWidth: isSet(object.towerWidth) ? globalThis.Number(object.towerWidth) : 0,
      towerDepth: isSet(object.towerDepth) ? globalThis.Number(object.towerDepth) : 0,
      nadirExecutionMode: isSet(object.nadirExecutionMode)
        ? waypointExecutionMode_EnumFromJSON(object.nadirExecutionMode)
        : 0,
      nadirFillImage: isSet(object.nadirFillImage) ? globalThis.Number(object.nadirFillImage) : 0,
      overviewExecutionMode: isSet(object.overviewExecutionMode)
        ? waypointExecutionMode_EnumFromJSON(object.overviewExecutionMode)
        : 0,
      overviewGimbalPitchDown: isSet(object.overviewGimbalPitchDown)
        ? globalThis.Number(object.overviewGimbalPitchDown)
        : 0,
      insulatorExecutionMode: isSet(object.insulatorExecutionMode)
        ? waypointExecutionMode_EnumFromJSON(object.insulatorExecutionMode)
        : 0,
      columnPlanType: isSet(object.columnPlanType) ? structureColumnType_EnumFromJSON(object.columnPlanType) : 0,
      useSemanticInspectionGimbalPitchUp: isSet(object.useSemanticInspectionGimbalPitchUp)
        ? globalThis.Boolean(object.useSemanticInspectionGimbalPitchUp)
        : false,
      semanticInspectionGimbalPitchUp: isSet(object.semanticInspectionGimbalPitchUp)
        ? globalThis.Number(object.semanticInspectionGimbalPitchUp)
        : 0,
      useSemanticInspectionGimbalPitchStraight: isSet(object.useSemanticInspectionGimbalPitchStraight)
        ? globalThis.Boolean(object.useSemanticInspectionGimbalPitchStraight)
        : false,
      useSemanticInspectionGimbalPitchDown: isSet(object.useSemanticInspectionGimbalPitchDown)
        ? globalThis.Boolean(object.useSemanticInspectionGimbalPitchDown)
        : false,
      semanticInspectionGimbalPitchDown: isSet(object.semanticInspectionGimbalPitchDown)
        ? globalThis.Number(object.semanticInspectionGimbalPitchDown)
        : 0,
      towerBodyExecutionMode: isSet(object.towerBodyExecutionMode)
        ? waypointExecutionMode_EnumFromJSON(object.towerBodyExecutionMode)
        : 0,
      towerBodyEnabled: isSet(object.towerBodyEnabled) ? globalThis.Boolean(object.towerBodyEnabled) : false,
      towerBodyTakePhoto: isSet(object.towerBodyTakePhoto) ? globalThis.Boolean(object.towerBodyTakePhoto) : false,
      towerBodyPitch: isSet(object.towerBodyPitch) ? globalThis.Number(object.towerBodyPitch) : 0,
      towerBodyOverlap: isSet(object.towerBodyOverlap) ? globalThis.Number(object.towerBodyOverlap) : 0,
      spanExecutionMode: isSet(object.spanExecutionMode)
        ? waypointExecutionMode_EnumFromJSON(object.spanExecutionMode)
        : 0,
      spanEnabled: isSet(object.spanEnabled) ? globalThis.Boolean(object.spanEnabled) : false,
      spanTakePhoto: isSet(object.spanTakePhoto) ? globalThis.Boolean(object.spanTakePhoto) : false,
      autonomousTowerAlignment: isSet(object.autonomousTowerAlignment)
        ? globalThis.Boolean(object.autonomousTowerAlignment)
        : false,
      useSemanticAim: isSet(object.useSemanticAim) ? globalThis.Boolean(object.useSemanticAim) : false,
      numberPitchAngles: isSet(object.numberPitchAngles) ? globalThis.Number(object.numberPitchAngles) : 0,
      nadirTakePhoto: isSet(object.nadirTakePhoto) ? globalThis.Boolean(object.nadirTakePhoto) : false,
      overviewEnabled: isSet(object.overviewEnabled) ? globalThis.Boolean(object.overviewEnabled) : false,
      overviewTakePhoto: isSet(object.overviewTakePhoto) ? globalThis.Boolean(object.overviewTakePhoto) : false,
      insulatorEnabled: isSet(object.insulatorEnabled) ? globalThis.Boolean(object.insulatorEnabled) : false,
      insulatorTakePhoto: isSet(object.insulatorTakePhoto) ? globalThis.Boolean(object.insulatorTakePhoto) : false,
      semanticInspectionGimbalPitchStraight: isSet(object.semanticInspectionGimbalPitchStraight)
        ? globalThis.Number(object.semanticInspectionGimbalPitchStraight)
        : 0,
      columnIndices: globalThis.Array.isArray(object?.columnIndices)
        ? object.columnIndices.map((e: any) => globalThis.Number(e))
        : [],
      compensationMode: isSet(object.compensationMode) ? compensationMode_EnumFromJSON(object.compensationMode) : 0,
      useGlobalMapFromRtk: isSet(object.useGlobalMapFromRtk) ? globalThis.Boolean(object.useGlobalMapFromRtk) : false,
      useExplorationPhase: isSet(object.useExplorationPhase) ? globalThis.Boolean(object.useExplorationPhase) : false,
      useMeshExplore: isSet(object.useMeshExplore) ? globalThis.Boolean(object.useMeshExplore) : false,
      useLongRangeExplore: isSet(object.useLongRangeExplore) ? globalThis.Boolean(object.useLongRangeExplore) : false,
      useOrbitExploration: isSet(object.useOrbitExploration) ? globalThis.Boolean(object.useOrbitExploration) : false,
      globalMaximumSpeed: isSet(object.globalMaximumSpeed) ? globalThis.Number(object.globalMaximumSpeed) : 0,
      globalSupportOutsideGeofencePoints: isSet(object.globalSupportOutsideGeofencePoints)
        ? globalThis.Boolean(object.globalSupportOutsideGeofencePoints)
        : false,
      splitExplorationIsEnabled: isSet(object.splitExplorationIsEnabled)
        ? globalThis.Boolean(object.splitExplorationIsEnabled)
        : false,
      splitExplorationIsCumulative: isSet(object.splitExplorationIsCumulative)
        ? globalThis.Boolean(object.splitExplorationIsCumulative)
        : false,
      splitExplorationIsTopToBottom: isSet(object.splitExplorationIsTopToBottom)
        ? globalThis.Boolean(object.splitExplorationIsTopToBottom)
        : false,
      splitExplorationSliceHeight: isSet(object.splitExplorationSliceHeight)
        ? globalThis.Number(object.splitExplorationSliceHeight)
        : 0,
      specificationSelection: isSet(object.specificationSelection)
        ? specificationSelection_EnumFromJSON(object.specificationSelection)
        : 0,
      usePillarCursor: isSet(object.usePillarCursor) ? globalThis.Boolean(object.usePillarCursor) : false,
      usePillarCursorMarker: isSet(object.usePillarCursorMarker)
        ? globalThis.Boolean(object.usePillarCursorMarker)
        : false,
      useExtremeCursor: isSet(object.useExtremeCursor) ? globalThis.Boolean(object.useExtremeCursor) : false,
      lockAwbAtFirstWaypoint: isSet(object.lockAwbAtFirstWaypoint)
        ? globalThis.Boolean(object.lockAwbAtFirstWaypoint)
        : false,
      lockAfAtFirstWaypoint: isSet(object.lockAfAtFirstWaypoint)
        ? globalThis.Boolean(object.lockAfAtFirstWaypoint)
        : false,
      useGpsScanPose: isSet(object.useGpsScanPose) ? globalThis.Boolean(object.useGpsScanPose) : false,
      lostCommsWaitTime: isSet(object.lostCommsWaitTime) ? globalThis.Number(object.lostCommsWaitTime) : 0,
      lostCommsRallyWaitTime: isSet(object.lostCommsRallyWaitTime)
        ? globalThis.Number(object.lostCommsRallyWaitTime)
        : 0,
      numPhotosPerOrbit: isSet(object.numPhotosPerOrbit) ? globalThis.Number(object.numPhotosPerOrbit) : 0,
      lookOutwards: isSet(object.lookOutwards) ? globalThis.Boolean(object.lookOutwards) : false,
      orbitCounterClockwise: isSet(object.orbitCounterClockwise)
        ? globalThis.Boolean(object.orbitCounterClockwise)
        : false,
      takeIrPhotos: isSet(object.takeIrPhotos) ? globalThis.Boolean(object.takeIrPhotos) : false,
      takeRawPhotos: isSet(object.takeRawPhotos) ? globalThis.Boolean(object.takeRawPhotos) : false,
      terrainFollow: isSet(object.terrainFollow) ? globalThis.Boolean(object.terrainFollow) : false,
      useRealTimeTerrainDetection: isSet(object.useRealTimeTerrainDetection)
        ? globalThis.Boolean(object.useRealTimeTerrainDetection)
        : false,
      userControls: isSet(object.userControls) ? UserControls.fromJSON(object.userControls) : undefined,
      dtedMapPath: isSet(object.dtedMapPath) ? globalThis.String(object.dtedMapPath) : "",
    };
  },

  toJSON(message: SettingsManager): unknown {
    const obj: any = {};
    if (message.scanModeLcm !== 0) {
      obj.scanModeLcm = scanMode_EnumToJSON(message.scanModeLcm);
    }
    if (message.runAreaScan === true) {
      obj.runAreaScan = message.runAreaScan;
    }
    if (message.runPerimeterScan === true) {
      obj.runPerimeterScan = message.runPerimeterScan;
    }
    if (message.runOrbitScan === true) {
      obj.runOrbitScan = message.runOrbitScan;
    }
    if (message.runMeshScan === true) {
      obj.runMeshScan = message.runMeshScan;
    }
    if (message.runContourZScan === true) {
      obj.runContourZScan = message.runContourZScan;
    }
    if (message.runContourYScan === true) {
      obj.runContourYScan = message.runContourYScan;
    }
    if (message.runContourXScan === true) {
      obj.runContourXScan = message.runContourXScan;
    }
    if (message.runContourCustomScan === true) {
      obj.runContourCustomScan = message.runContourCustomScan;
    }
    if (message.runManualScan === true) {
      obj.runManualScan = message.runManualScan;
    }
    if (message.runColumnScan === true) {
      obj.runColumnScan = message.runColumnScan;
    }
    if (message.runVertexColumnScan === true) {
      obj.runVertexColumnScan = message.runVertexColumnScan;
    }
    if (message.runStructureColumnInspectionScan === true) {
      obj.runStructureColumnInspectionScan = message.runStructureColumnInspectionScan;
    }
    if (message.runDiagonalScan === true) {
      obj.runDiagonalScan = message.runDiagonalScan;
    }
    if (message.stopForPhoto === true) {
      obj.stopForPhoto = message.stopForPhoto;
    }
    if (message.ignoreTranslationMotionBlurConstraint === true) {
      obj.ignoreTranslationMotionBlurConstraint = message.ignoreTranslationMotionBlurConstraint;
    }
    if (message.maxMotionBlurPx !== 0) {
      obj.maxMotionBlurPx = Math.round(message.maxMotionBlurPx);
    }
    if (message.overlapPercentage !== 0) {
      obj.overlapPercentage = message.overlapPercentage;
    }
    if (message.distanceToSurface !== 0) {
      obj.distanceToSurface = message.distanceToSurface;
    }
    if (message.showArCoverageMesh === true) {
      obj.showArCoverageMesh = message.showArCoverageMesh;
    }
    if (message.awbMode !== 0) {
      obj.awbMode = awbMode_EnumToJSON(message.awbMode);
    }
    if (message.exposureMode !== 0) {
      obj.exposureMode = exposureMode_EnumToJSON(message.exposureMode);
    }
    if (message.autofocusRegion !== undefined) {
      obj.autofocusRegion = AutoRegionRequest.toJSON(message.autofocusRegion);
    }
    if (message.autofocusMode !== 0) {
      obj.autofocusMode = autofocusMode_EnumToJSON(message.autofocusMode);
    }
    if (message.eoRecordingMode !== 0) {
      obj.eoRecordingMode = recordingMode_EnumToJSON(message.eoRecordingMode);
    }
    if (message.geofenceStrictCeiling === true) {
      obj.geofenceStrictCeiling = message.geofenceStrictCeiling;
    }
    if (message.geofenceCeilOffset !== 0) {
      obj.geofenceCeilOffset = message.geofenceCeilOffset;
    }
    if (message.geofenceStrictFloor === true) {
      obj.geofenceStrictFloor = message.geofenceStrictFloor;
    }
    if (message.geofenceFloorOffset !== 0) {
      obj.geofenceFloorOffset = message.geofenceFloorOffset;
    }
    if (message.geofenceStrictLateral === true) {
      obj.geofenceStrictLateral = message.geofenceStrictLateral;
    }
    if (message.geofenceLateralOffset !== 0) {
      obj.geofenceLateralOffset = message.geofenceLateralOffset;
    }
    if (message.geofenceOffsetFloorFromPolygonPrismCeiling === true) {
      obj.geofenceOffsetFloorFromPolygonPrismCeiling = message.geofenceOffsetFloorFromPolygonPrismCeiling;
    }
    if (message.minDistanceFromSurface !== 0) {
      obj.minDistanceFromSurface = message.minDistanceFromSurface;
    }
    if (message.useGeofenceArea === true) {
      obj.useGeofenceArea = message.useGeofenceArea;
    }
    if (message.exteriorCaptureCeil === true) {
      obj.exteriorCaptureCeil = message.exteriorCaptureCeil;
    }
    if (message.exteriorCaptureFloor === true) {
      obj.exteriorCaptureFloor = message.exteriorCaptureFloor;
    }
    if (message.exteriorCaptureLateral === true) {
      obj.exteriorCaptureLateral = message.exteriorCaptureLateral;
    }
    if (message.scanVolumeInside === true) {
      obj.scanVolumeInside = message.scanVolumeInside;
    }
    if (message.scanVolumeExtendCaptureDistance !== 0) {
      obj.scanVolumeExtendCaptureDistance = message.scanVolumeExtendCaptureDistance;
    }
    if (message.areaScanHeight !== 0) {
      obj.areaScanHeight = message.areaScanHeight;
    }
    if (message.areaOverlap !== 0) {
      obj.areaOverlap = message.areaOverlap;
    }
    if (message.areaSidelap !== 0) {
      obj.areaSidelap = message.areaSidelap;
    }
    if (message.areaGimbalPitch !== 0) {
      obj.areaGimbalPitch = message.areaGimbalPitch;
    }
    if (message.enableCrossHatch === true) {
      obj.enableCrossHatch = message.enableCrossHatch;
    }
    if (message.crossHatchGimbalAngle !== 0) {
      obj.crossHatchGimbalAngle = message.crossHatchGimbalAngle;
    }
    if (message.enableCustomFlightLegDirection === true) {
      obj.enableCustomFlightLegDirection = message.enableCustomFlightLegDirection;
    }
    if (message.customFlightLegDirection !== 0) {
      obj.customFlightLegDirection = message.customFlightLegDirection;
    }
    if (message.enableCustomCameraHeading === true) {
      obj.enableCustomCameraHeading = message.enableCustomCameraHeading;
    }
    if (message.ccwPerpendicularCameraHeading === true) {
      obj.ccwPerpendicularCameraHeading = message.ccwPerpendicularCameraHeading;
    }
    if (message.scanPlaneOffsetFromNavTakeoff !== 0) {
      obj.scanPlaneOffsetFromNavTakeoff = message.scanPlaneOffsetFromNavTakeoff;
    }
    if (message.perimeterOverlap !== 0) {
      obj.perimeterOverlap = message.perimeterOverlap;
    }
    if (message.perimeterGimbalPitch !== 0) {
      obj.perimeterGimbalPitch = message.perimeterGimbalPitch;
    }
    if (message.perimeterNumHeights !== 0) {
      obj.perimeterNumHeights = Math.round(message.perimeterNumHeights);
    }
    if (message.perimeterMinDistanceToScanPlane !== 0) {
      obj.perimeterMinDistanceToScanPlane = message.perimeterMinDistanceToScanPlane;
    }
    if (message.diagonalOverlap !== 0) {
      obj.diagonalOverlap = message.diagonalOverlap;
    }
    if (message.diagonalGimbalPitch !== 0) {
      obj.diagonalGimbalPitch = message.diagonalGimbalPitch;
    }
    if (message.rollingShutterCorrection === true) {
      obj.rollingShutterCorrection = message.rollingShutterCorrection;
    }
    if (message.isLookupScan === true) {
      obj.isLookupScan = message.isLookupScan;
    }
    if (message.orbitSidelap !== 0) {
      obj.orbitSidelap = message.orbitSidelap;
    }
    if (message.orbitGimbalPitch !== 0) {
      obj.orbitGimbalPitch = message.orbitGimbalPitch;
    }
    if (message.orbitUseHelix === true) {
      obj.orbitUseHelix = message.orbitUseHelix;
    }
    if (message.numColumns !== 0) {
      obj.numColumns = Math.round(message.numColumns);
    }
    if (message.columnOverlap !== 0) {
      obj.columnOverlap = message.columnOverlap;
    }
    if (message.columnGimbalPitch !== 0) {
      obj.columnGimbalPitch = message.columnGimbalPitch;
    }
    if (message.contourDesiredRange !== 0) {
      obj.contourDesiredRange = message.contourDesiredRange;
    }
    if (message.contourWaypointOverlapPercentage !== 0) {
      obj.contourWaypointOverlapPercentage = message.contourWaypointOverlapPercentage;
    }
    if (message.contourSliceOverlapPercentage !== 0) {
      obj.contourSliceOverlapPercentage = message.contourSliceOverlapPercentage;
    }
    if (message.contourZLookdownAngle !== 0) {
      obj.contourZLookdownAngle = message.contourZLookdownAngle;
    }
    if (message.avoidRedundantCoverage === true) {
      obj.avoidRedundantCoverage = message.avoidRedundantCoverage;
    }
    if (message.adjustUnreachablePhotos === true) {
      obj.adjustUnreachablePhotos = message.adjustUnreachablePhotos;
    }
    if (message.contourNumPasses !== 0) {
      obj.contourNumPasses = Math.round(message.contourNumPasses);
    }
    if (message.contourPassMultiplier !== 0) {
      obj.contourPassMultiplier = message.contourPassMultiplier;
    }
    if (message.contourSlicePitch !== 0) {
      obj.contourSlicePitch = message.contourSlicePitch;
    }
    if (message.contourSliceYaw !== 0) {
      obj.contourSliceYaw = message.contourSliceYaw;
    }
    if (message.contourSmallGapsDistance !== 0) {
      obj.contourSmallGapsDistance = message.contourSmallGapsDistance;
    }
    if (message.contourLongRange === true) {
      obj.contourLongRange = message.contourLongRange;
    }
    if (message.verticalOverlapFractionPercentage !== 0) {
      obj.verticalOverlapFractionPercentage = message.verticalOverlapFractionPercentage;
    }
    if (message.gimbalPitchDeg !== 0) {
      obj.gimbalPitchDeg = message.gimbalPitchDeg;
    }
    if (message.lengthTower !== 0) {
      obj.lengthTower = message.lengthTower;
    }
    if (message.upAndOverHeight !== 0) {
      obj.upAndOverHeight = message.upAndOverHeight;
    }
    if (message.standoffDistance !== 0) {
      obj.standoffDistance = message.standoffDistance;
    }
    if (message.explorationOrbitRadius !== 0) {
      obj.explorationOrbitRadius = message.explorationOrbitRadius;
    }
    if (message.explorationOrbitHeight !== 0) {
      obj.explorationOrbitHeight = message.explorationOrbitHeight;
    }
    if (message.towerHeight !== 0) {
      obj.towerHeight = message.towerHeight;
    }
    if (message.towerWidth !== 0) {
      obj.towerWidth = message.towerWidth;
    }
    if (message.towerDepth !== 0) {
      obj.towerDepth = message.towerDepth;
    }
    if (message.nadirExecutionMode !== 0) {
      obj.nadirExecutionMode = waypointExecutionMode_EnumToJSON(message.nadirExecutionMode);
    }
    if (message.nadirFillImage !== 0) {
      obj.nadirFillImage = message.nadirFillImage;
    }
    if (message.overviewExecutionMode !== 0) {
      obj.overviewExecutionMode = waypointExecutionMode_EnumToJSON(message.overviewExecutionMode);
    }
    if (message.overviewGimbalPitchDown !== 0) {
      obj.overviewGimbalPitchDown = message.overviewGimbalPitchDown;
    }
    if (message.insulatorExecutionMode !== 0) {
      obj.insulatorExecutionMode = waypointExecutionMode_EnumToJSON(message.insulatorExecutionMode);
    }
    if (message.columnPlanType !== 0) {
      obj.columnPlanType = structureColumnType_EnumToJSON(message.columnPlanType);
    }
    if (message.useSemanticInspectionGimbalPitchUp === true) {
      obj.useSemanticInspectionGimbalPitchUp = message.useSemanticInspectionGimbalPitchUp;
    }
    if (message.semanticInspectionGimbalPitchUp !== 0) {
      obj.semanticInspectionGimbalPitchUp = message.semanticInspectionGimbalPitchUp;
    }
    if (message.useSemanticInspectionGimbalPitchStraight === true) {
      obj.useSemanticInspectionGimbalPitchStraight = message.useSemanticInspectionGimbalPitchStraight;
    }
    if (message.useSemanticInspectionGimbalPitchDown === true) {
      obj.useSemanticInspectionGimbalPitchDown = message.useSemanticInspectionGimbalPitchDown;
    }
    if (message.semanticInspectionGimbalPitchDown !== 0) {
      obj.semanticInspectionGimbalPitchDown = message.semanticInspectionGimbalPitchDown;
    }
    if (message.towerBodyExecutionMode !== 0) {
      obj.towerBodyExecutionMode = waypointExecutionMode_EnumToJSON(message.towerBodyExecutionMode);
    }
    if (message.towerBodyEnabled === true) {
      obj.towerBodyEnabled = message.towerBodyEnabled;
    }
    if (message.towerBodyTakePhoto === true) {
      obj.towerBodyTakePhoto = message.towerBodyTakePhoto;
    }
    if (message.towerBodyPitch !== 0) {
      obj.towerBodyPitch = message.towerBodyPitch;
    }
    if (message.towerBodyOverlap !== 0) {
      obj.towerBodyOverlap = message.towerBodyOverlap;
    }
    if (message.spanExecutionMode !== 0) {
      obj.spanExecutionMode = waypointExecutionMode_EnumToJSON(message.spanExecutionMode);
    }
    if (message.spanEnabled === true) {
      obj.spanEnabled = message.spanEnabled;
    }
    if (message.spanTakePhoto === true) {
      obj.spanTakePhoto = message.spanTakePhoto;
    }
    if (message.autonomousTowerAlignment === true) {
      obj.autonomousTowerAlignment = message.autonomousTowerAlignment;
    }
    if (message.useSemanticAim === true) {
      obj.useSemanticAim = message.useSemanticAim;
    }
    if (message.numberPitchAngles !== 0) {
      obj.numberPitchAngles = Math.round(message.numberPitchAngles);
    }
    if (message.nadirTakePhoto === true) {
      obj.nadirTakePhoto = message.nadirTakePhoto;
    }
    if (message.overviewEnabled === true) {
      obj.overviewEnabled = message.overviewEnabled;
    }
    if (message.overviewTakePhoto === true) {
      obj.overviewTakePhoto = message.overviewTakePhoto;
    }
    if (message.insulatorEnabled === true) {
      obj.insulatorEnabled = message.insulatorEnabled;
    }
    if (message.insulatorTakePhoto === true) {
      obj.insulatorTakePhoto = message.insulatorTakePhoto;
    }
    if (message.semanticInspectionGimbalPitchStraight !== 0) {
      obj.semanticInspectionGimbalPitchStraight = message.semanticInspectionGimbalPitchStraight;
    }
    if (message.columnIndices?.length) {
      obj.columnIndices = message.columnIndices.map((e) => Math.round(e));
    }
    if (message.compensationMode !== 0) {
      obj.compensationMode = compensationMode_EnumToJSON(message.compensationMode);
    }
    if (message.useGlobalMapFromRtk === true) {
      obj.useGlobalMapFromRtk = message.useGlobalMapFromRtk;
    }
    if (message.useExplorationPhase === true) {
      obj.useExplorationPhase = message.useExplorationPhase;
    }
    if (message.useMeshExplore === true) {
      obj.useMeshExplore = message.useMeshExplore;
    }
    if (message.useLongRangeExplore === true) {
      obj.useLongRangeExplore = message.useLongRangeExplore;
    }
    if (message.useOrbitExploration === true) {
      obj.useOrbitExploration = message.useOrbitExploration;
    }
    if (message.globalMaximumSpeed !== 0) {
      obj.globalMaximumSpeed = message.globalMaximumSpeed;
    }
    if (message.globalSupportOutsideGeofencePoints === true) {
      obj.globalSupportOutsideGeofencePoints = message.globalSupportOutsideGeofencePoints;
    }
    if (message.splitExplorationIsEnabled === true) {
      obj.splitExplorationIsEnabled = message.splitExplorationIsEnabled;
    }
    if (message.splitExplorationIsCumulative === true) {
      obj.splitExplorationIsCumulative = message.splitExplorationIsCumulative;
    }
    if (message.splitExplorationIsTopToBottom === true) {
      obj.splitExplorationIsTopToBottom = message.splitExplorationIsTopToBottom;
    }
    if (message.splitExplorationSliceHeight !== 0) {
      obj.splitExplorationSliceHeight = message.splitExplorationSliceHeight;
    }
    if (message.specificationSelection !== 0) {
      obj.specificationSelection = specificationSelection_EnumToJSON(message.specificationSelection);
    }
    if (message.usePillarCursor === true) {
      obj.usePillarCursor = message.usePillarCursor;
    }
    if (message.usePillarCursorMarker === true) {
      obj.usePillarCursorMarker = message.usePillarCursorMarker;
    }
    if (message.useExtremeCursor === true) {
      obj.useExtremeCursor = message.useExtremeCursor;
    }
    if (message.lockAwbAtFirstWaypoint === true) {
      obj.lockAwbAtFirstWaypoint = message.lockAwbAtFirstWaypoint;
    }
    if (message.lockAfAtFirstWaypoint === true) {
      obj.lockAfAtFirstWaypoint = message.lockAfAtFirstWaypoint;
    }
    if (message.useGpsScanPose === true) {
      obj.useGpsScanPose = message.useGpsScanPose;
    }
    if (message.lostCommsWaitTime !== 0) {
      obj.lostCommsWaitTime = message.lostCommsWaitTime;
    }
    if (message.lostCommsRallyWaitTime !== 0) {
      obj.lostCommsRallyWaitTime = message.lostCommsRallyWaitTime;
    }
    if (message.numPhotosPerOrbit !== 0) {
      obj.numPhotosPerOrbit = Math.round(message.numPhotosPerOrbit);
    }
    if (message.lookOutwards === true) {
      obj.lookOutwards = message.lookOutwards;
    }
    if (message.orbitCounterClockwise === true) {
      obj.orbitCounterClockwise = message.orbitCounterClockwise;
    }
    if (message.takeIrPhotos === true) {
      obj.takeIrPhotos = message.takeIrPhotos;
    }
    if (message.takeRawPhotos === true) {
      obj.takeRawPhotos = message.takeRawPhotos;
    }
    if (message.terrainFollow === true) {
      obj.terrainFollow = message.terrainFollow;
    }
    if (message.useRealTimeTerrainDetection === true) {
      obj.useRealTimeTerrainDetection = message.useRealTimeTerrainDetection;
    }
    if (message.userControls !== undefined) {
      obj.userControls = UserControls.toJSON(message.userControls);
    }
    if (message.dtedMapPath !== "") {
      obj.dtedMapPath = message.dtedMapPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SettingsManager>, I>>(base?: I): SettingsManager {
    return SettingsManager.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SettingsManager>, I>>(object: I): SettingsManager {
    const message = createBaseSettingsManager();
    message.scanModeLcm = object.scanModeLcm ?? 0;
    message.runAreaScan = object.runAreaScan ?? false;
    message.runPerimeterScan = object.runPerimeterScan ?? false;
    message.runOrbitScan = object.runOrbitScan ?? false;
    message.runMeshScan = object.runMeshScan ?? false;
    message.runContourZScan = object.runContourZScan ?? false;
    message.runContourYScan = object.runContourYScan ?? false;
    message.runContourXScan = object.runContourXScan ?? false;
    message.runContourCustomScan = object.runContourCustomScan ?? false;
    message.runManualScan = object.runManualScan ?? false;
    message.runColumnScan = object.runColumnScan ?? false;
    message.runVertexColumnScan = object.runVertexColumnScan ?? false;
    message.runStructureColumnInspectionScan = object.runStructureColumnInspectionScan ?? false;
    message.runDiagonalScan = object.runDiagonalScan ?? false;
    message.stopForPhoto = object.stopForPhoto ?? false;
    message.ignoreTranslationMotionBlurConstraint = object.ignoreTranslationMotionBlurConstraint ?? false;
    message.maxMotionBlurPx = object.maxMotionBlurPx ?? 0;
    message.overlapPercentage = object.overlapPercentage ?? 0;
    message.distanceToSurface = object.distanceToSurface ?? 0;
    message.showArCoverageMesh = object.showArCoverageMesh ?? false;
    message.awbMode = object.awbMode ?? 0;
    message.exposureMode = object.exposureMode ?? 0;
    message.autofocusRegion = (object.autofocusRegion !== undefined && object.autofocusRegion !== null)
      ? AutoRegionRequest.fromPartial(object.autofocusRegion)
      : undefined;
    message.autofocusMode = object.autofocusMode ?? 0;
    message.eoRecordingMode = object.eoRecordingMode ?? 0;
    message.geofenceStrictCeiling = object.geofenceStrictCeiling ?? false;
    message.geofenceCeilOffset = object.geofenceCeilOffset ?? 0;
    message.geofenceStrictFloor = object.geofenceStrictFloor ?? false;
    message.geofenceFloorOffset = object.geofenceFloorOffset ?? 0;
    message.geofenceStrictLateral = object.geofenceStrictLateral ?? false;
    message.geofenceLateralOffset = object.geofenceLateralOffset ?? 0;
    message.geofenceOffsetFloorFromPolygonPrismCeiling = object.geofenceOffsetFloorFromPolygonPrismCeiling ?? false;
    message.minDistanceFromSurface = object.minDistanceFromSurface ?? 0;
    message.useGeofenceArea = object.useGeofenceArea ?? false;
    message.exteriorCaptureCeil = object.exteriorCaptureCeil ?? false;
    message.exteriorCaptureFloor = object.exteriorCaptureFloor ?? false;
    message.exteriorCaptureLateral = object.exteriorCaptureLateral ?? false;
    message.scanVolumeInside = object.scanVolumeInside ?? false;
    message.scanVolumeExtendCaptureDistance = object.scanVolumeExtendCaptureDistance ?? 0;
    message.areaScanHeight = object.areaScanHeight ?? 0;
    message.areaOverlap = object.areaOverlap ?? 0;
    message.areaSidelap = object.areaSidelap ?? 0;
    message.areaGimbalPitch = object.areaGimbalPitch ?? 0;
    message.enableCrossHatch = object.enableCrossHatch ?? false;
    message.crossHatchGimbalAngle = object.crossHatchGimbalAngle ?? 0;
    message.enableCustomFlightLegDirection = object.enableCustomFlightLegDirection ?? false;
    message.customFlightLegDirection = object.customFlightLegDirection ?? 0;
    message.enableCustomCameraHeading = object.enableCustomCameraHeading ?? false;
    message.ccwPerpendicularCameraHeading = object.ccwPerpendicularCameraHeading ?? false;
    message.scanPlaneOffsetFromNavTakeoff = object.scanPlaneOffsetFromNavTakeoff ?? 0;
    message.perimeterOverlap = object.perimeterOverlap ?? 0;
    message.perimeterGimbalPitch = object.perimeterGimbalPitch ?? 0;
    message.perimeterNumHeights = object.perimeterNumHeights ?? 0;
    message.perimeterMinDistanceToScanPlane = object.perimeterMinDistanceToScanPlane ?? 0;
    message.diagonalOverlap = object.diagonalOverlap ?? 0;
    message.diagonalGimbalPitch = object.diagonalGimbalPitch ?? 0;
    message.rollingShutterCorrection = object.rollingShutterCorrection ?? false;
    message.isLookupScan = object.isLookupScan ?? false;
    message.orbitSidelap = object.orbitSidelap ?? 0;
    message.orbitGimbalPitch = object.orbitGimbalPitch ?? 0;
    message.orbitUseHelix = object.orbitUseHelix ?? false;
    message.numColumns = object.numColumns ?? 0;
    message.columnOverlap = object.columnOverlap ?? 0;
    message.columnGimbalPitch = object.columnGimbalPitch ?? 0;
    message.contourDesiredRange = object.contourDesiredRange ?? 0;
    message.contourWaypointOverlapPercentage = object.contourWaypointOverlapPercentage ?? 0;
    message.contourSliceOverlapPercentage = object.contourSliceOverlapPercentage ?? 0;
    message.contourZLookdownAngle = object.contourZLookdownAngle ?? 0;
    message.avoidRedundantCoverage = object.avoidRedundantCoverage ?? false;
    message.adjustUnreachablePhotos = object.adjustUnreachablePhotos ?? false;
    message.contourNumPasses = object.contourNumPasses ?? 0;
    message.contourPassMultiplier = object.contourPassMultiplier ?? 0;
    message.contourSlicePitch = object.contourSlicePitch ?? 0;
    message.contourSliceYaw = object.contourSliceYaw ?? 0;
    message.contourSmallGapsDistance = object.contourSmallGapsDistance ?? 0;
    message.contourLongRange = object.contourLongRange ?? false;
    message.verticalOverlapFractionPercentage = object.verticalOverlapFractionPercentage ?? 0;
    message.gimbalPitchDeg = object.gimbalPitchDeg ?? 0;
    message.lengthTower = object.lengthTower ?? 0;
    message.upAndOverHeight = object.upAndOverHeight ?? 0;
    message.standoffDistance = object.standoffDistance ?? 0;
    message.explorationOrbitRadius = object.explorationOrbitRadius ?? 0;
    message.explorationOrbitHeight = object.explorationOrbitHeight ?? 0;
    message.towerHeight = object.towerHeight ?? 0;
    message.towerWidth = object.towerWidth ?? 0;
    message.towerDepth = object.towerDepth ?? 0;
    message.nadirExecutionMode = object.nadirExecutionMode ?? 0;
    message.nadirFillImage = object.nadirFillImage ?? 0;
    message.overviewExecutionMode = object.overviewExecutionMode ?? 0;
    message.overviewGimbalPitchDown = object.overviewGimbalPitchDown ?? 0;
    message.insulatorExecutionMode = object.insulatorExecutionMode ?? 0;
    message.columnPlanType = object.columnPlanType ?? 0;
    message.useSemanticInspectionGimbalPitchUp = object.useSemanticInspectionGimbalPitchUp ?? false;
    message.semanticInspectionGimbalPitchUp = object.semanticInspectionGimbalPitchUp ?? 0;
    message.useSemanticInspectionGimbalPitchStraight = object.useSemanticInspectionGimbalPitchStraight ?? false;
    message.useSemanticInspectionGimbalPitchDown = object.useSemanticInspectionGimbalPitchDown ?? false;
    message.semanticInspectionGimbalPitchDown = object.semanticInspectionGimbalPitchDown ?? 0;
    message.towerBodyExecutionMode = object.towerBodyExecutionMode ?? 0;
    message.towerBodyEnabled = object.towerBodyEnabled ?? false;
    message.towerBodyTakePhoto = object.towerBodyTakePhoto ?? false;
    message.towerBodyPitch = object.towerBodyPitch ?? 0;
    message.towerBodyOverlap = object.towerBodyOverlap ?? 0;
    message.spanExecutionMode = object.spanExecutionMode ?? 0;
    message.spanEnabled = object.spanEnabled ?? false;
    message.spanTakePhoto = object.spanTakePhoto ?? false;
    message.autonomousTowerAlignment = object.autonomousTowerAlignment ?? false;
    message.useSemanticAim = object.useSemanticAim ?? false;
    message.numberPitchAngles = object.numberPitchAngles ?? 0;
    message.nadirTakePhoto = object.nadirTakePhoto ?? false;
    message.overviewEnabled = object.overviewEnabled ?? false;
    message.overviewTakePhoto = object.overviewTakePhoto ?? false;
    message.insulatorEnabled = object.insulatorEnabled ?? false;
    message.insulatorTakePhoto = object.insulatorTakePhoto ?? false;
    message.semanticInspectionGimbalPitchStraight = object.semanticInspectionGimbalPitchStraight ?? 0;
    message.columnIndices = object.columnIndices?.map((e) => e) || [];
    message.compensationMode = object.compensationMode ?? 0;
    message.useGlobalMapFromRtk = object.useGlobalMapFromRtk ?? false;
    message.useExplorationPhase = object.useExplorationPhase ?? false;
    message.useMeshExplore = object.useMeshExplore ?? false;
    message.useLongRangeExplore = object.useLongRangeExplore ?? false;
    message.useOrbitExploration = object.useOrbitExploration ?? false;
    message.globalMaximumSpeed = object.globalMaximumSpeed ?? 0;
    message.globalSupportOutsideGeofencePoints = object.globalSupportOutsideGeofencePoints ?? false;
    message.splitExplorationIsEnabled = object.splitExplorationIsEnabled ?? false;
    message.splitExplorationIsCumulative = object.splitExplorationIsCumulative ?? false;
    message.splitExplorationIsTopToBottom = object.splitExplorationIsTopToBottom ?? false;
    message.splitExplorationSliceHeight = object.splitExplorationSliceHeight ?? 0;
    message.specificationSelection = object.specificationSelection ?? 0;
    message.usePillarCursor = object.usePillarCursor ?? false;
    message.usePillarCursorMarker = object.usePillarCursorMarker ?? false;
    message.useExtremeCursor = object.useExtremeCursor ?? false;
    message.lockAwbAtFirstWaypoint = object.lockAwbAtFirstWaypoint ?? false;
    message.lockAfAtFirstWaypoint = object.lockAfAtFirstWaypoint ?? false;
    message.useGpsScanPose = object.useGpsScanPose ?? false;
    message.lostCommsWaitTime = object.lostCommsWaitTime ?? 0;
    message.lostCommsRallyWaitTime = object.lostCommsRallyWaitTime ?? 0;
    message.numPhotosPerOrbit = object.numPhotosPerOrbit ?? 0;
    message.lookOutwards = object.lookOutwards ?? false;
    message.orbitCounterClockwise = object.orbitCounterClockwise ?? false;
    message.takeIrPhotos = object.takeIrPhotos ?? false;
    message.takeRawPhotos = object.takeRawPhotos ?? false;
    message.terrainFollow = object.terrainFollow ?? false;
    message.useRealTimeTerrainDetection = object.useRealTimeTerrainDetection ?? false;
    message.userControls = (object.userControls !== undefined && object.userControls !== null)
      ? UserControls.fromPartial(object.userControls)
      : undefined;
    message.dtedMapPath = object.dtedMapPath ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
